module.exports = __webpack_public_path__ + "static/media/icon-unread-notification.4e0283d4.svg";